<template>
  <div class="main-container-info">
    <div class="image-container">
      <img class="image" :src="onboardingInfo.imageUrl" />
    </div>
    <div class="modal-text-container">
      <h4 class="modal-title">{{ onboardingInfo.title }}</h4>
      <p class="modal-description">{{ onboardingInfo.description }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'onboarding-modal-info',
  props: {
    onboardingInfo: Object,
  },
  data() {
    return {}
  },
}
</script>

<style scoped>
.main-container-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
}
.image-container {
  height: fit-content;
  width: 100%;
  max-width: 439px;
}
.image {
  object-fit: cover;
  width: 100%;
}
.modal-text-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
}
.modal-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 120%;
  text-align: center;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #666666;
}
.modal-description {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  text-align: center;
  color: #666666;
}
</style>
